import axios, { AxiosInstance } from 'axios';
import { userManager } from '../oidcAuth';

const LEX_API_BASE_URL = import.meta.env.VITE_OIDC_AUTHORITY || 'https://homolog-api.lex.education';

export class LexApiClient {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: LEX_API_BASE_URL,
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
    });

    this.axiosInstance.interceptors.request.use(async (config) => {
      const user = await userManager.getUser();
      const token = user?.access_token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          console.error("Lex API returned 401. Dispatching sessionExpired event.");
          window.dispatchEvent(new CustomEvent('sessionExpired'));
        }
        return Promise.reject(error);
      }
    );
  }

  async get<T>(endpoint: string): Promise<T> {
    const response = await this.axiosInstance.get<T>(endpoint);
    return response.data;
  }
}
